// src/systems/inventorySystem.ts — Fase 5 modular
import { getItem } from '../data/items.js';
import type { PlayerState } from '../entities/player.js';
import { store } from '../app/state.js';
import { saveLocal } from '../app/storage.js';

export function addItem(state: PlayerState, itemId:string, qty:number): boolean {
  const def = getItem(itemId);
  if(!def) return false;
  const existing = state.inventory.find(i=> i.id===itemId);
  if(existing){
    if(!def.stackable && qty>0) return false;
    existing.qty += qty;
  } else {
    state.inventory.push({ id:itemId, qty });
  }
  store.setState(state); saveLocal(state);
  return true;
}

export function removeItem(state: PlayerState, itemId:string, qty:number): boolean {
  const idx = state.inventory.findIndex(i=> i.id===itemId);
  if(idx===-1) return false;
  const it = state.inventory[idx];
  if(it.qty < qty) return false;
  it.qty -= qty;
  if(it.qty<=0) state.inventory.splice(idx,1);
  store.setState(state); saveLocal(state);
  return true;
}

export function hasItem(state: PlayerState, itemId:string, qty=1): boolean {
  const it = state.inventory.find(i=> i.id===itemId);
  return !!it && it.qty >= qty;
}

export function canSell(itemId:string): boolean {
  const def = getItem(itemId);
  if(!def) return false;
  if(def.keyItem) return false;
  return def.sellPrice > 0;
}
